import { ListItemButton, ListItemIcon } from "@mui/material";
import { IRouteType } from "../../../models/IRouteType";
import colorConfigs from "../../../configs/colorConfigs";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { typo } from "../../../assets/fonts/font";

type Props = {
    item: IRouteType
};

const SideBarItem = ({ item }: Props) => {

    const { appState } = useSelector((state: RootState) => state.appState)

    return (
        item.sidebarProps && item.path ? (
            <ListItemButton
                component={Link}
                to={item.path}
                sx={{
                    ...typo.sideBar,
                    color: colorConfigs.secondary,
                    "&: hover": {
                        backgroundColor: colorConfigs.tertiary
                    },
                    backgroundColor: appState === item.state ? colorConfigs.tertiary : "unset",
                    paddingY: "12px",
                    paddingX: "24px",
                }}
            >
                <ListItemIcon sx={{
                    color: colorConfigs.secondary
                }}>
                    {item.sidebarProps.icon && item.sidebarProps.icon}
                </ListItemIcon>
                {item.sidebarProps.displayText}
            </ListItemButton>
        ) : null
    );
};

export default SideBarItem;